import React from 'react';
import { withRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module'
import { Container, Row, Image, Carousel } from 'react-bootstrap';
// import MetaTags from 'react-meta-tags';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import * as actionCreators from '../store/actions';
import Footer from '../components/footer';
import capitalize from 'lodash/capitalize';
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loaders';
import isNull from 'lodash/isNull';
import isEmpty from 'lodash/isEmpty';
import $ from 'jquery';
import { isMobileOnly } from 'react-device-detect';
import isStringArabic from "../store/isStringArabic"
import CartMenu from '../components/CartMenu';
import SubscribedNavbar from "../components/SubscribedNavbar"



class ProductDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			media: {},
			whatsappLink: '',
			businessName: '',
			zoomImage: false,
			activeSlideIndex: 0,
			bucketExpaned: false,
			sizeInCart: ""
		};
	}
	async UNSAFE_componentWillMount() {
		const tagManagerArgs = {
			gtmId: 'GTM-N9VH3SG',
			auth: "L30oIK794waeC2pZS76yUw",
			preview:"env-3"
		}
		TagManager.initialize(tagManagerArgs)
		await this.props.setUserLocation();

		const location = this.props.location;
		// console.log('location', location);

		const productId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
		// if (location.state && location.state.media) {
		// const whatsappMesageLink = location.state.whatsappLink;
		// console.log('location.state.media', location.state.media);
		// console.log('qs', qs.parse(location.search));
		// const result = qs.parse(location.search);
		// console.log('productId', productId);
		// console.log('did mount this.props.currency', this.props.currency);
		this.props.searchForProductOnBackEnd(productId, this.props.history, this.props.currency)

	}
	componentDidUpdate(prevProps) {
		if (
			!isNull(this.props.instagramAccountInfo.snap_pixel_script) &&
			!isEmpty(this.props.instagramAccountInfo.snap_pixel_script) &&
			prevProps.instagramAccountInfo.snap_pixel_script !== this.props.instagramAccountInfo.snap_pixel_script
		) {
			const tagManagerArgs = {
				gtmId: 'GTM-N9VH3SG',
				auth: "L30oIK794waeC2pZS76yUw",
				preview:"env-3"
			}
			TagManager.initialize(tagManagerArgs)
			var embedCode = this.props.instagramAccountInfo.snap_pixel_script; // <script>//my js script code</script>
			$('head').append(embedCode);
		}

		if (prevProps.productDescription !== this.props.productDetail &&
			(this.props.productDetail.id !== undefined && this.props.productDetail.id !== null)) {
		let productObj = this.props.productDetail;
			const currency = this.props.currency
			const prices = this.props.productDetail.prices && this.props.productDetail.prices.length > 0 &&
				this.props.productDetail.prices.find(pr => pr.currency === currency)
		  // window.dataLayer.push({
      // 'event': 'view_item',
      // 'ecommerce': {
      //   'items': [{
      //     'item_name': productObj.productName, // Name or ID is required.
			// 		'item_id': productObj.id,
			// 		// 'item_description': productObj.productDescription,
      //     // 'item_brand': productObj.brand,
      //     // 'item_category': productObj.category,
      //     // 'item_category_2': productObj.category_2,
      //     // 'item_category_3': productObj.category_3,
      //     // 'item_category_4': productObj.category_4,
      //     // 'item_variant': productObj.variant,
      //     // 'item_list_name': productObj.list_name,
      //     // 'item_list_id': productObj.list_id,
      //     // 'index': productObj.index,
      //     // 'quantity': productObj.quantity,
			// 		'item_unit_price': prices ? parseFloat(prices.price) : "",
			// 		'currency': currency
      //   	}]
      // 	}
    	// });
	
			// Measure a view of product details. This example assumes the detail view occurs on pageload,
			// and also tracks a standard pageview of the details page.
			window.dataLayer.push({
				'ecommerce': {
					'detail': {
						'actionField': {'list': 'Explore Products'},    // 'detail' actions have an optional list property.
						'products': [{
							'name': productObj.productName,         // Name or ID is required.
							'id':  productObj.id,
							'price': prices ? parseFloat(prices.price) : "",
							// 'brand': 'Google',
							// 'category': 'Apparel',
							// 'variant': 'Gray'
						}]
					}
				}
			});
		}
		// if (!this.props.instagramAccountInfo.productDetail.imageId) {
		// 	const location = this.props.location;
		// 	const productId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
		// 	this.props.getInstagramAccountDetail(this.props.history, productId);
		// }
	}
	componentDidMount() {
		this.props.myCartList()
		this.props.getLanguageListPOEdit(this.props.pathname === "/ar" ? "ar" : "en")
		// console.log('state', this.props);
		// const location = this.props.location;
		// if (location.state && location.state.media) {
		// const whatsappMesageLink = location.state.whatsappLink;
		// console.log('location.state.media', location.state.media);
		// console.log('qs', qs.parse(location.search));
		// const result = qs.parse(location.search);
		// this.props.getInstagramAccountDetail(this.props.history, result.productId);
		// const productMessage =
		// 	encodeURIComponent(location.state.media.imageUrl) +
		// 	`\n \n Hi there.\
		// The ${location.state.media.imageUrl} looks great!\
		// Is it available for delivery?`;
		// // TODO: `replace this link in state when actual product name comes up
		// const newWhatsappLink =
		// 	whatsappMesageLink +
		// 	`&text=https://${location.state.businessName}.optimizeapp.com/productDetail/${
		// 		location.state.media.imageId
		//     }`;
		// const newWhatsappLink =
		// 	whatsappMesageLink + `&text=http://192.168.8.110:3000/productDetail/${location.state.media.imageId}`;
		// console.log('new link', newWhatsappLink);
		// this.setState({
		// 	media: location.state.media,
		// 	whatsappLink: whatsappMesageLink,

		// 	// whatsappLink: newWhatsappLink,
		// 	businessName: location.state.businessName,
		// });
		// }
		window.scrollTo(0, 0);
	}
	goToPreviousPage = () => {
		this.props.history.goBack();
	};

	goToWhatsApp = () => {
		// msg: ===>  Hi there.The product looks great! Is it available for delivery ?
		if (this.props.instagramAccountInfo.button_action === "whatsapp" || this.props.productDetail.button_action === "whatsapp") {
			const button_message = this.props.pathname === "/ar" && this.props.productDetail.button_message_ar
				? this.props.productDetail.button_message_ar
				: this.props.productDetail.button_message
					? this.props.productDetail.button_message
					: this.props.instagramAccountInfo.button_message
			console.log('button_message', button_message);
			const whatsappLink = encodeURI(
				(this.props.instagramAccountInfo.whatsappLink || this.props.productDetail.whatsappLink) +
				`&text=https://www.instagram.com/p/${this.props.productDetail.shortcode}/\n\n${button_message}`
			);
			// console.log('Link', whatsappLink);

			window.open(whatsappLink, '_blank');
		} else {
			if (
				!isNull(this.props.instagramAccountInfo.snap_pixel_script) &&
				!isEmpty(this.props.instagramAccountInfo.snap_pixel_script) &&
				this.props.instagramAccountInfo.snap_pixel_script) {
				window.snaptr('track', 'VIEW_CONTENT')
			}
			window.open(`https://www.instagram.com/p/${this.props.productDetail.shortcode}/`, '_blank');

		}
		// if (
		// 	this.props.instagramAccountInfo.instagram_campaign_enabled === '1' ||
		// 	!this.props.instagramAccountInfo.whatsappnumber ||
		// 	this.props.instagramAccountInfo.businessName === 'thecoffeeworkshop'
		// ) {
		// 	window.open(`https://www.instagram.com/p/${this.props.productDetail.shortcode}/`, '_blank');
		// } 
	};

	onImgLoad = ({ target: img }) => {
		if (img.offsetWidth > img.offsetHeight) {
			this.setState({
				zoomImage: true
			})
		}
	}
	characterLimit = () => {
		let description = ""
		if (!this.props.loadingInstaDetail && this.props.productDetail
			&& this.props.productDetail.productDescription && this.props.productDetail.productDescription.length > 250) {
			description = this.props.productDetail.productDescription.substring(0, 249) + "..."
		} else {
			description = this.props.productDetail.productDescription
		}
		return description
	}
	closeCartMenu = () => {
		this.setState({
			bucketExpaned: false
		})
	}
	expandBucket = () => {
		this.setState({
			bucketExpaned: true
		})
	}
	render() {
		document.body.classList.remove('inner-page');

		const translate = this.props.translate


		const currency = this.props.currency
		const prices = this.props.productDetail.prices && this.props.productDetail.prices.length > 0 && this.props.productDetail.prices.find(pr => pr.currency === currency)
		// console.log('prductDetail screen', this.props.productDetail);
		// console.log('insatgramAccountInfo screen', this.props.instagramAccountInfo);

		return (
			<div className="outerDivProductDetail">
				<Helmet>
					<title>OptimizeApp</title>
					<link
						rel="canonical"
						href={`https://${this.props.instagramAccountInfo.businessName}.optimizeapp.com/productDetail/${this.props.productDetail.imageId}`}
					/>
					{/* <link
						rel="canonical"
						href={`http://192.168.8.110:3000/productDetail/${this.state.media.imageId}`}
					/> */}
					<meta
						name="og:title"
						itemProp="title"
						content={capitalize(this.props.instagramAccountInfo.businessName)}
					/>
					<meta
						name="og:description"
						itemProp="description"
						content={this.props.productDetail.productDescription}
					/>
					{/* <meta property="og:type" content="article" /> */}
					<meta property="og:image" itemProp="image" content={this.props.productDetail.imageUrl} />
					{/* <meta property="og:image" content={''} /> */}

					<meta
						property="og:url"
						itemProp="url"
						content={`https://${this.props.instagramAccountInfo.businessName}.optimizeapp.com/productDetail/${this.props.productDetail.imageId}`}
					/>
					{/* <meta
						property="og:url"
						content={`http://192.168.8.110:3000/productDetail/${this.state.media.imageId}`}
					/> */}
				</Helmet>


				{/* <div className={`topNavBar ${this.props.language === "ar" && "topNavBarRTL"}`}
					style={{
						filter: window.innerWidth <= 991 && (this.state.menuExpaned || this.state.bucketExpaned) ? "blur(5px)" : "none"
					}}
				>

					<Row className="brandImageRow">
						<Image className="brandImage" src={this.props.instagramAccountInfo.brandProfilePic} onError={this.errorLoadingPicture} />
					</Row>
					<Row
						className="brandNameText"
						style={{
							fontFamily: isStringArabic(this.props.instagramAccountInfo.brandName)
								? 'Changa-bold'
								: 'Montserrat-bold',
						}}
					>
						{this.props.instagramAccountInfo.brandName}
					</Row>
					<Image className="headLogo" src={"assets/images/LogoPurple.svg"} />

					<p className={`poweredSlideText ${this.props.language === "ar" && "arabic"}`}>
						{translate[`This site is Powered by Optimize App`]}
					</p>
					<a
						href="https://app.adjust.com/fw3cwi8?label=OptimizeShop&redirect=https%3A%2F%2Fwww.optimizeapp.com%2Fdownload"
						target="_blank"
						rel="noopener noreferrer"
						className={`getYoursText ${this.props.language === "ar" && "arabic"}`}>
						{translate[`Get yours now!`]}
					</a>
					<p onClick={this.changeLanguage} className={`languageButton ${this.props.language === "en" && "arabic"} ${this.props.language === "ar" && " languageButtonRTL"}`} >
						{this.props.language === "en" ? "العربية" : "English"}
					</p>
				</div> */}



				<SubscribedNavbar
					productDetail={true}
					categories={this.props.categories}
					expandBucket={this.expandBucket}
					translate={this.props.translate}
					cartList={this.props.cartList}
					instagramAccountInfo={this.props.instagramAccountInfo}
					language={this.props.language}
					history={this.props.history}
				/>
				<CartMenu
					currency={this.props.currency}
					translate={this.props.translate}
					cartList={this.props.cartList}
					closeCartMenu={this.closeCartMenu}
					bucketExpaned={this.state.bucketExpaned}
				/>
				<Container className="mainHome">

					<Container
						className="innerBlockProduct"
						style={this.props.loadingInstaDetail ? { height: '50%' } : {}}
					>
						{/* <Image
							className="closeButton"
							src="/clientwebsite2/assets/images/svgs/PurpleArrow.svg"
							onClick={this.goToPreviousPage}
						/> */}
						<Row
							className="productImageRow"
							style={
								this.props.loadingInstaDetail ? { alignItems: 'center', justifyContent: 'center' } : {
									width: isMobileOnly ? window.innerWidth - 80 : 475,
									height: isMobileOnly ? window.innerWidth - 80 : 475
								}
							}
						>

							{this.props.productDetail && this.props.productDetail.media && this.props.productDetail.media.length > 1 ?
								<Carousel activeIndex={this.state.activeSlideIndex} onSelect={(index) => {
									this.setState({
										activeSlideIndex: index
									})
								}}
									// controls={window.innerWidth > 991}
									interval={150000} className={`productDetailImage ${this.state.zoomImage && "zoomImage"}`} >
									{

										this.props.productDetail.media.map(img =>
											(<Carousel.Item key={img.url} className={`productDetailImage ${this.state.zoomImage && "zoomImage"}`} >{

												this.props.loadingInstaDetail ?
													(
														<Loader
															innerClassName="productDetailImage"
															active={this.props.loadingInstaDetail}
															type="ball-scale"
														/>
													) : (
														<Image
															className={`productDetailImage ${this.state.zoomImage && "zoomImage"}`}
															// style={{
															// 	width: window.innerWidth
															// }}
															onLoad={this.onImgLoad}
															src={img.url}
															alt={this.props.productDetail.productName}
														/>
													)
											}
											</Carousel.Item>
											)
										)}
								</Carousel>
								:
								this.props.loadingInstaDetail ? (
									<Loader
										innerClassName="productDetailImage"
										active={this.props.loadingInstaDetail}
										type="ball-scale"
									/>
								) : (
										<Image
											className={`productDetailImage ${this.state.zoomImage && "zoomImage"}`}
											// style={{
											// 	width: window.innerWidth
											// }}
											onLoad={this.onImgLoad}
											src={this.props.productDetail.imageUrl}
											alt={this.props.productDetail.productName}
										/>
									)
							}


						</Row>
					</Container>
				</Container>



				<Container className="productInfoContainer">
					<h4 className="productName"
						style={{
							fontFamily:
								isStringArabic(translate[this.props.instagramAccountInfo.web_heading_key_name])
									? "Changa-bold"
									: "Montserrat-bold"
						}}>
						{!this.props.loadingInstaDetail &&
							this.props.productDetail &&
							this.props.productDetail.productName
							? this.props.productDetail.productName
							: translate[this.props.instagramAccountInfo.web_heading_key_name]}
					</h4>

					<p className="productDescription"
					// Uncomment this styling  if needed
					// style={{ fontFamily: isStringArabic(this.props.productDetail.productDescription) ? "Changa" : "Montserrat-regular" }}
					>
						{this.props.loadingInstaDetail ? '' : this.characterLimit()}
					</p>
					<div>
						<p className="availableSizeText">
							Available Sizes
						</p>
						<div className={"sizesViewInner"}>
							{["XS", "S", "M", "L", "XL"].map(size =>
								<div key={size} onClick={() => {
									this.setState({
										sizeInCart: size
									})
								}} className={`sizeSubView ${this.state.sizeInCart === size && "selectedSizeSubView"}`}>
									<p className={`sizeText ${this.state.sizeInCart === size && "selectedSizeText"}`}>{size}</p>
								</div>)}
						</div>
					</div>



				</Container>
				<div className={"mainDetailFooter"}>
					<div>
						<h3 className="priceTextFooter">
							{translate["PRICE"]}
						</h3>
						<h5 className="priceFooter">

							{!this.props.loadingInstaDetail &&
								prices ? (
									<div>
										<span>{prices.currency}</span>
										{prices.price}
									</div>
								) : translate["Contact us for prices"]}
						</h5>
					</div>
					{/* <button
						variant="secondary"
						disabled={this.props.loadingInstaDetail || !this.props.productDetail.shortcode}
						className="orderButton"
						id={'shopnow'}
						onClick={() => {

							if (button_action === "call") {
								document.location.href = `tel:${this.props.instagramAccountInfo.telephoneNumber}`
							}
							if (button_action === "snapchat" || this.props.pathname === "/snap") {
								window.open(`https://www.snapchat.com/add/${this.props.instagramAccountInfo.snapchat_handle}`)
							}
							if (this.props.instagramAccountInfo.button_action !== "call" && this.props.instagramAccountInfo.button_action !== "snapchat"
								&& this.props.productDetail.shortcode) {
								this.goToWhatsApp();
							}
						}}
						style={{
							fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.button_text]) ? "Changa-bold" : "Montserrat-bold"
						}}
					>
						 <Image
							src={`/assets/images/svgs/${this.props.pathname === "/snap" ? "snapchat-outline" : this.props.instagramAccountInfo.button_icon}.svg`}
						/>
						{this.props.pathname === "/snap" ? "المشاهدة" : translate[this.props.instagramAccountInfo.button_text]}
					</button> */}
					<button
						variant="secondary"
						disabled={this.props.loadingInstaDetail
							// ||
							// !this.props.productDetail.shortcode
						}
						className="orderButton"
						id={'shopnow'}
						onClick={() => {
							// navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;

							this.setState({
								bucketExpaned: true
							})
							this.props.addProductToMyCart(this.props.productDetail.id)
						}}
					// style={{
					// 	fontFamily: isStringArabic(translate[this.props.instagramAccountInfo.button_text]) ? "Changa-bold" : "Montserrat-bold"
					// }}
					>
						{translate['ADD TO CART']}
					</button>

				</div>

				<Footer translate={this.props.translate} imagesList={this.props.instagramAccountInfo.imagesList} />
			</div >
		);
	}
}

const mapDispatchToProps = dispatch => ({
	getInstagramAccountDetail: (history, productId) =>
		dispatch(actionCreators.getInstagramAccountDetail(history, productId)),
	getLanguageListPOEdit: (language) => dispatch(actionCreators.getLanguageListPOEdit(language)),
	searchForProductOnBackEnd: (productId, history, currency) => dispatch(actionCreators.searchForProductOnBackEnd(productId, history, currency)),
	setUserLocation: () => dispatch(actionCreators.setUserLocation()),
	addProductToMyCart: (product_id) => dispatch(actionCreators.addProductToMyCart(product_id)),
	myCartList: () => dispatch(actionCreators.myCartList())
});
const mapStateToProps = state => ({
	languages: state.campaign.languages,
	instagramAccountInfo: state.campaign.instagramAccountInfo,
	productDetail: state.campaign.instagramAccountInfo.productDetail,
	errorMessage: state.campaign.errorMessage,
	loadingInstaDetail: state.campaign.loadingInstaDetail,
	pathname: state.login.pathname,
	translate: state.websiteLanguage.translations,
	currency: state.login.currency,
	cartList: state.cart.cartList,
	categories: state.campaign.categories
});
export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(ProductDetail)
);



// WEBPACK FOOTER //
// ./src/pages/ProductDetail.js